/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type UsageFileStatusEnum = 'RECEIVED' | 'INVALID' | 'PROCESSED';

export const UsageFileStatusEnum = {

    RECEIVED: 'RECEIVED' as UsageFileStatusEnum,

    INVALID: 'INVALID' as UsageFileStatusEnum,

    PROCESSED: 'PROCESSED' as UsageFileStatusEnum
};

